module.exports = __webpack_public_path__ + "img/government-economy.0cd0ed05.png";